import { z } from 'zod';
/**
 * ContactProfile — outbound caller-ID and per-contact configuration.
 * Used as the "from" identity on calls / SMS / emails. Mirrors the
 * `ContactProfile` schema in `packages/shared/openapi/public.yaml`.
 */
export const AssignedToTypeSchema = z.enum(['extension', 'queue', 'callgroup']);
export const AssignedToSchema = z.object({
    type: AssignedToTypeSchema,
    /** Wildix extension number, queue id, or callgroup id depending on `type`. */
    value: z.string().min(1),
});
export const OrganizationAddressSchema = z
    .object({
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    postal_code: z.string().optional(),
    country: z.string().optional(),
})
    .strict();
export const ContactProfileSchema = z.object({
    id: z.string().regex(/^cp_[A-Za-z0-9_-]+$/),
    customer_id: z.string().regex(/^cust_[A-Za-z0-9_-]+$/),
    name: z.string().min(1).max(120),
    contact_name: z.string().min(1).max(120).optional(),
    organization_name: z.string().max(120).optional(),
    /** Caller ID Number — should be E.164. */
    direct_number: z.string().min(1).max(32).optional(),
    reply_to_email: z.string().email().optional(),
    organization_logo_url: z.string().url().nullable().optional(),
    organization_address: OrganizationAddressSchema.optional(),
    /** IANA timezone name (e.g., "America/Chicago"). */
    timezone: z.string().min(1).max(64).optional(),
    /** Press-0 / Kite-link routing target. */
    assigned_to: AssignedToSchema.optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const ContactProfileCreateSchema = ContactProfileSchema.omit({
    id: true,
    customer_id: true,
    created_at: true,
    updated_at: true,
});
//# sourceMappingURL=contacts.js.map